/**
 * The refusals of a list's free-text term (KPR-739; keepr-api docs/SCHEMA.md,
 * "Free text", Refusals). A search the server will not run is a 400 with a
 * `code`; the list keeps its rows and its other filters, and the search box
 * says what the server said (KPR-740).
 *
 *   search_term_empty            nothing to look for
 *   search_term_too_long         over 200 characters        { limit }
 *   search_term_too_many_words   over 8 words               { limit }
 *   search_term_invalid          `me`, a {{reference}}, a list, a NUL, a bare number
 *   search_too_broad             the term would read too many fields of this list
 *   unsupported_operator         on the `text` field only   { field: 'text', operator }
 *
 * (A search that runs past the request budget is a 503 `query_timeout`, not a
 * refusal: the feed's own failure row with Retry says it.)
 */

export const SEARCH_REFUSAL_CODES = Object.freeze([
	'search_term_empty',
	'search_term_too_long',
	'search_term_too_many_words',
	'search_term_invalid',
	'search_too_broad',
]);

/** The server's own limit on a term's length, mirrored only to avoid SENDING an absurd one (a URL of thousands of characters). */
export const SEARCH_MAX_CHARS = 200;

/** Whether a 400 body is the refusal of the search term (and not of the rest of the filter). */
export function isSearchRefusal(body) {
	if (!body || typeof body !== 'object') return false;
	if (SEARCH_REFUSAL_CODES.includes(body.code)) return true;
	// A refusal of the operator is the search's only when it names the `text` field.
	return body.code === 'unsupported_operator' && body.field === 'text';
}

/** The sentence a refusal is said in: the server's own, else a plain one. */
export function searchRefusalSentence(body, fallback = '') {
	const text = body && typeof body.message === 'string' ? body.message.trim() : '';
	return text || fallback || 'That search could not be run.';
}
